/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

import type { BvBtnArgs } from '../bv-btn';

interface BvEmptySearchResultSignature {
  Args: {
    description?: string;
    primaryAction?: Omit<BvBtnArgs, 'text'> & { content: BvBtnArgs['text'] };
    title?: string;
  };
  Blocks: {
    action: [];
  };
  Element: HTMLElement;
}

const BvEmptySearchResultComponent = templateOnlyComponent<BvEmptySearchResultSignature>();

export default BvEmptySearchResultComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvEmptySearchResult: typeof BvEmptySearchResultComponent;
    'bv-empty-search-result': typeof BvEmptySearchResultComponent;
  }
}
